import React, { useContext } from 'react';
import { TableLayoutContext } from '../../layout-context';
const renderMap = {
    block: ({ children, ...props }) => (React.createElement("div", { role: "rowgroup", "aria-label": "body", className: "body", ...props }, children)),
    table: ({ children, ...props }) => React.createElement("tbody", { ...props }, children)
};
export const TableBody = ({ children, ...props }) => {
    const layoutType = useContext(TableLayoutContext);
    const renderTable = renderMap[layoutType];
    return renderTable({ children, ...props });
};
TableBody.displayName = 'TableBody';
